import axios from "axios";
import * as Constants from "../../constant";
const URL = Constants?.LOCAL_URL;

export const login = async (data) => {
	try {
		const res = await axios.post(`${URL}/api/auth/login`, data, {
			withCredentials: true,
		});
		return {
			type: "USER_INFORMATION",
			payload: res?.data.userData,
			status: res?.status,
		};
	} catch (error) {
		return {
			type: "USER_INFORMATION",
			payload: error,
		};
	}
};
export const logoutAction = () => {
	return {
		type: "RESET_APP",
		payload: "",
		status: "",
	};
};

export const userInformation = async (UserId) => {
	try {
		const resposne = await axios.get(
			`${URL}/addresses/findprofile/${UserId}`
		);
		return {
			type: "USER_INFORMATION",
			payload: resposne?.data,
			status: 201,
		};
	} catch (error) {
		return {
			type: "USER_INFORMATION",
			payload: error,
		};
	}
};

